<div class="page-container account-review-container container">
  <app-breadcrumb [crumbConfig]="crumbConfig"></app-breadcrumb>

  @if (accountId === '') {
    <app-rb-grid
      [gridConfig]="gridConfig"
      [getSetup]="getGridSetup"
      [getData]="getGridData"
    ></app-rb-grid>
  } @else {
    <app-account-review-detail
      [accountId]="accountId"
    ></app-account-review-detail>
  }
</div>
